import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  IRIBuffering,
  API_PATH_IRI_BUFFERING,
} from './iriBuffering.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getIRIBuffering(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<IRIBuffering>> {
  return http.get(`${API_PATH_IRI_BUFFERING}/${deliveryFunctionId}`);
}

export function updateIRIBuffering(
  deliveryFunctionId: string,
  body: WithAuditDetails<IRIBuffering>,
): AxiosPromise<ServerResponse<IRIBuffering>> {
  return http.put(`${API_PATH_IRI_BUFFERING}/${deliveryFunctionId}/${body.data.id}`, body);
}
